import { asnStates } from '../../const/asnStates'

export const handleColorState = (stateAsn: string) => {
  switch (stateAsn) {
    case asnStates.PENDIENTE: {
      return '#0063E3'
    }

    case asnStates.RECEPCIONADA: {
      return '#FF9C28'
    }

    case asnStates.FINALIZADA_INCOMPLETA_ES: {
      return '#FF9C28'
    }

    case asnStates.FINALIZADA: {
      return '#199D03'
    }

    case asnStates.FINALIZADA_COMPLETA_ES: {
      return '#199D03'
    }

    case asnStates.ANULADA: {
      return '#DC0404'
    }
    default: {
      return '#000000'
    }
  }
}
